import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import AutoInVendita from "@/pages/AutoInVendita";
import VehicleDetail from "@/pages/VehicleDetail";
import BookingWizard from "@/pages/BookingWizard";
import Confirmation from "@/pages/Confirmation";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ContractPage from "@/pages/ContractPage";
import LandingPage from "@/pages/LandingPage";
import Faq from "@/pages/Faq";
import BodyshopJobPage from "@/pages/BodyshopJobPage";
import OperatorSheetPage from "@/pages/OperatorSheetPage";
import ConsuntivoPage from "@/pages/ConsuntivoPage";
import Carrozzeria from "@/pages/Carrozzeria";
import Grandine from "@/pages/Grandine";
import { LANDINGS } from "@/lib/seoPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/domande-frequenti" element={<Faq />} />
            <Route path="/carrozzeria-pontedera" element={<Carrozzeria />} />
            <Route path="/riparazione-grandine" element={<Grandine />} />
            {Object.keys(LANDINGS).map((slug) => <Route key={slug} path={`/${slug}`} element={<LandingPage />} />)}
            <Route path="/cars" element={<Fleet />} />
            <Route path="/vendita" element={<AutoInVendita />} />
            <Route path="/vendita/:id" element={<VehicleDetail />} />
            <Route path="/book/:carId" element={<BookingWizard />} />
            <Route path="/booking/:code" element={<Confirmation />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/contratto/:id" element={<ProtectedRoute><ContractPage /></ProtectedRoute>} />
            <Route path="/admin/carrozzeria/scheda-operatore" element={<ProtectedRoute><OperatorSheetPage /></ProtectedRoute>} />
            <Route path="/admin/carrozzeria/:id/consuntivo" element={<ProtectedRoute><ConsuntivoPage /></ProtectedRoute>} />
            <Route path="/admin/carrozzeria/:id" element={<ProtectedRoute><BodyshopJobPage /></ProtectedRoute>} />
          </Routes>
          <FloatingWhatsApp />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
